<div class="flex justify-center h-full">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Reset Password</h2>
    <form id="forgotPasswordForm" #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Verification Code</mat-label>
        <input matInput type="verificationCode" maxlength="50" name="verificationCode" id="verificationCode" required [(ngModel)]="verificationCode" #Code="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>New Password</mat-label>
        <input matInput [type]="hide ? 'password' : 'text'" type="password" name="Password" id="Password" required [(ngModel)]="Password" #Pass="ngModel">
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <button mat-flat-button color="primary" type="submit" class="my-2" [disabled]="!forgotPasswordForm.form.valid">SAVE PASSWORD</button>
    </form>
    <button class="my-1 self-center" mat-button color="accent" [routerLink]="['/forgot']" style="color: #545859">Send a New Code</button>
  </div>

</div>
